import { ApiService } from '../../../types/api';
import type {
  MetafieldConfigurationResponse,
  MetafieldGroup,
  PlatformConnectRequest,
  PlatformConnectResponse,
} from '../types';

export interface PlatformApiContract {
  connect(
    teamSlug: string,
    environment: string,
    payload: PlatformConnectRequest,
  ): Promise<PlatformConnectResponse>;
  metafieldConfiguration(siteId: string, siteEnv: string): Promise<MetafieldGroup[]>;
  enableMetafield(siteId: string, siteEnv: string, key: string): Promise<void>;
}

declare module '../../../context/page-context' {
  interface Apis {
    platform: PlatformApiContract;
  }
}

export class PlatformApi extends ApiService implements PlatformApiContract {
  public connect(
    teamSlug: string,
    environment: string,
    payload: PlatformConnectRequest,
  ): Promise<PlatformConnectResponse> {
    return this.api.fetch<PlatformConnectResponse>({
      method: 'POST',
      path: `/${teamSlug}/${environment}/platform`,
      payload,
    });
  }

  public async metafieldConfiguration(siteId: string, siteEnv: string): Promise<MetafieldGroup[]> {
    const groups = await this.api.fetch<MetafieldConfigurationResponse>({
      method: 'GET',
      path: `/${siteId}/${siteEnv}/ignite/metafield-configuration`,
    });

    return Object.values(groups).map((group) => ({
      name: group.name,
      metafields: Object.values(group.metafields ?? {}),
    }));
  }

  public enableMetafield(siteId: string, siteEnv: string, key: string): Promise<void> {
    return this.api.fetch<void>({
      method: 'POST',
      path: `/${siteId}/${siteEnv}/ignite/metafield-configuration/enable/${key}`,
    });
  }
}
